<template>
  <div class="min-h-screen bg-cream pb-20">

    <!-- Хэдер -->
    <div class="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] z-40 bg-cream/90 backdrop-blur-sm">
      <div class="flex items-center gap-3 px-4 pb-3" style="padding-top: calc(48px + var(--safe-top));">
        <button @click="router.back()" class="w-9 h-9 flex items-center justify-center rounded-full bg-[#E0DAD0]">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#41291A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
        <span class="text-15 text-ink/70 truncate flex-1">Статьи Зожника</span>
      </div>
    </div>

    <!-- Контент -->
    <div class="pt-[88px] px-4">

      <!-- Загрузка -->
      <div v-if="loading" class="flex justify-center pt-20">
        <div class="w-6 h-6 border-2 border-[#C4B8A8] border-t-[#8B7B6B] rounded-full animate-spin"/>
      </div>

      <!-- Ошибка -->
      <div v-else-if="error" class="text-center pt-20">
        <p class="text-ink/70 text-16">Статья не найдена</p>
        <button @click="router.back()" class="mt-4 text-14 text-ink/70 underline">Назад</button>
      </div>

      <!-- Статья -->
      <template v-else-if="article">
        <!-- Мета -->
        <div class="flex items-center gap-2 text-13 text-ink/70 mb-3">
          <span v-if="article.category">{{ article.category }}</span>
          <span v-if="article.category">·</span>
          <span v-if="article.word_count">{{ Math.ceil(article.word_count / 200) }} мин чтения</span>
          <span v-if="article.published_at">· {{ formatDate(article.published_at) }}</span>
        </div>

        <!-- Заголовок -->
        <h1 class="text-24 font-bold text-ink leading-snug mb-4">
          {{ article.title }}
        </h1>

        <!-- Контент -->
        <div class="article-content text-16 text-[#2A2A2A] leading-relaxed" v-html="article.content"/>
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '../services/api.js'
import { absolutizeHtml } from '../utils/image.js'

const route   = useRoute()
const router  = useRouter()
const article = ref(null)
const loading = ref(true)
const error   = ref(false)

onMounted(async () => {
  try {
    const { data } = await api.get(`/articles/${route.params.slug}`)
    // Абсолютизация один раз при загрузке, а не в шаблоне на каждый ре-рендер
    if (data) data.content = absolutizeHtml(data.content)
    article.value = data
  } catch {
    error.value = true
  } finally {
    loading.value = false
  }
})

function formatDate(iso) {
  return new Date(iso).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}
</script>

<style scoped>
.article-content :deep(img) {
  width: 100%;
  border-radius: 12px;
  margin: 16px 0;
  height: auto;
}
.article-content :deep(h2) {
  font-size: var(--fs-20);
  font-weight: 700;
  margin: 24px 0 8px;
  color: var(--ink);
}
.article-content :deep(h3) {
  font-size: var(--fs-17);
  font-weight: 600;
  margin: 20px 0 6px;
  color: var(--ink);
}
.article-content :deep(p) {
  margin: 0 0 14px;
}
.article-content :deep(ul),
.article-content :deep(ol) {
  padding-left: 20px;
  margin: 0 0 14px;
}
.article-content :deep(li) {
  margin-bottom: 6px;
}
.article-content :deep(a) {
  color: var(--ink-70);
  text-decoration: underline;
}
.article-content :deep(blockquote) {
  border-left: 3px solid #C4B8A8;
  padding-left: 16px;
  color: var(--ink-80);
  margin: 16px 0;
}
.article-content :deep(figure) {
  margin: 16px 0;
}
.article-content :deep(figcaption) {
  text-align: center;
  font-size: var(--fs-13);
  color: var(--ink-70);
  margin-top: 6px;
}
</style>
